var _module_exports = "<h3>WHY?</h3>\n\n<p>\n  Specific details will help us to pair you with the most relevant expert\n  and that means a faster turnaround.\n</p>\n";;
var path = 'views/tasks/modal_description.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;